// extracted by mini-css-extract-plugin
module.exports = {"styles":"_3NpDCwiesslrGJU5o4jelD"};